import React from 'react';

import {TwoColumnLayout} from '@/component';
import JobsList from './JobsList';

import useTitle from '@/hook/useTitle';

export default function LogsPage() {
    useTitle('定时任务 - 系统管理');

    return (
        <TwoColumnLayout>
            <TwoColumnLayout.ContentPanel>
                <JobsList />
            </TwoColumnLayout.ContentPanel>
        </TwoColumnLayout>
    );
}
